import { Badge } from '../../ui/badge';
import { ticketStatusClass, ticketStatusLabel } from '../../../data/crmTicketConstants';

export default function CrmTicketStatusBadge({ status, statuses = [] }) {
  return (
    <Badge variant="secondary" className={ticketStatusClass(status)}>
      {ticketStatusLabel(status, statuses)}
    </Badge>
  );
}
